import { MutationTree } from 'vuex'
import { Subscription } from '~/models/organization/subscription/Subscription'
import { SubscriptionState } from '~/store/organization/subscriptions/state'

export default {
  set(state, subscriptions) {
    state.subscriptions = subscriptions
  },
  add(state, subscription) {
    state.subscriptions.unshift(subscription)
  },
  delete(state, subscriptionId) {
    state.subscriptions = state.subscriptions.filter(
      ({ id }) => id !== subscriptionId
    )
  },
  update(state, { id: subscriptionId, emailInterval }) {
    const updatedList = state.subscriptions.map((subscription) => {
      if (subscription.id === subscriptionId) {
        subscription.emailInterval = emailInterval
      }
      return subscription
    })
    state.subscriptions = updatedList as Subscription[]
  }
} as MutationTree<SubscriptionState>
